<template>
	<div>
		<v-subheader>{{getObjectValue('name', customer)}}</v-subheader>

		<v-btn color="primary" @click="save">Save Customer</v-btn>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from "vuex";
	export default {
		data() {
			return {
				permissions: []
			};
		},

		props: {
			id: {
				default: null
			}
		},

		computed: {
			...mapGetters("admin", {
				SELECTED_PART: "selectedPart",
			}),

			customer() {
				return this.SELECTED_PART(this.id);
			},
		},

		methods: {
			...mapActions("admin", {

			}),

			save() {

			}
		},
	};
</script>
